import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AIChatMessage } from './aichat.model';
import { ShellComponent } from 'src/app/layout/shell/shell.component';
import { CognitoService } from 'src/app/core/service/cognito.service';


@Component({
  selector: 'app-aichatmessage',
  templateUrl: './aichatmessage.component.html',
  styleUrls: ['./aichatmessage.component.scss'],
  providers: [DatePipe],
  standalone: false
})
export class AIChatMessageComponent {

    @Input() content!: AIChatMessage;
    @ViewChild('contentContainer') contentContainer: ElementRef | undefined;
    @ViewChild('infoButton') infoButton: ElementRef | undefined;


    constructor(
        private datePipe: DatePipe,
        private shellComponent: ShellComponent,
        private readonly cognitoService: CognitoService,
    ) {}

    ngAfterViewInit() {
        this.scrollToBottom();
    }

    scrollToBottom() {
        if(!this.contentContainer) return;
        try {
            this.contentContainer.nativeElement.scrollTop = this.contentContainer.nativeElement.scrollHeight;
        } catch(err) { }
      }

    getTime(): string {
        if (this.content.timestamp) {
            return this.datePipe.transform(this.content.timestamp, 'short') || '';
        } else {
            return '';
        }
    }

    getUsername(): string {
        return this.content.isAI ? 'Talonic AI' : this.cognitoService.getLoggedInUserName();
    }

    async openSheet(sheetId:string) {
        await this.shellComponent.loadData(sheetId);
    }

    getUserInitial() {
        return this.cognitoService.getLoggedInUserName()[0].toUpperCase();
    }

}
